import { createFileRoute, Outlet } from '@tanstack/react-router';
import type { JSX } from 'react';

import { NavigationSidebarPartLibrary } from '@/app/navigation/NavigationSidebarPartLibrary';
import type { PageStaticData } from '@/shared/routing';
import { SidebarRouteLayout } from '@/shared/ui/PageLayoutCollapsibleSidebar';

// The pages beside the Parts sidebar; the details, offer and linking pages and the other importers stay outside this group.
export const Route = createFileRoute('/_authenticated/parts/_sidebar')({
    // Each page checks who may open it.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return (
        <SidebarRouteLayout sidebar={<NavigationSidebarPartLibrary />}>
            <Outlet />
        </SidebarRouteLayout>
    );
}
